import React from 'react';
import { Home, Grid, Heart, ShoppingBag } from 'lucide-react';

interface MobileNavProps {
  onNavigate: (sectionId: string) => void;
  onCartClick: () => void;
  onWishlistClick: () => void;
  cartCount: number;
  wishlistCount: number;
}

export const MobileNav: React.FC<MobileNavProps> = ({
  onNavigate,
  onCartClick,
  onWishlistClick,
  cartCount,
  wishlistCount
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-100 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] md:hidden">
      <div className="flex justify-around items-center h-16 pb-safe">
        <button 
          onClick={() => onNavigate('home')} 
          className="flex flex-col items-center justify-center w-full h-full text-gray-500 hover:text-herbal-800 active:text-herbal-800 transition-colors gap-1 group"
        >
          <Home className="h-5 w-5 group-hover:scale-110 transition-transform" />
          <span className="text-[10px] font-medium font-heading">Home</span>
        </button>
        
        <button 
          onClick={() => onNavigate('products')} 
          className="flex flex-col items-center justify-center w-full h-full text-gray-500 hover:text-herbal-800 active:text-herbal-800 transition-colors gap-1 group"
        >
          <Grid className="h-5 w-5 group-hover:scale-110 transition-transform" />
          <span className="text-[10px] font-medium font-heading">Shop</span>
        </button>
        
        <button 
          onClick={onWishlistClick} 
          className="flex flex-col items-center justify-center w-full h-full text-gray-500 hover:text-herbal-800 active:text-herbal-800 transition-colors gap-1 relative group"
        >
          <div className="relative">
            <Heart className="h-5 w-5 group-hover:scale-110 transition-transform" />
            {wishlistCount > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-turmeric-500 text-white text-[9px] font-bold rounded-full h-3.5 w-3.5 flex items-center justify-center border border-white shadow-sm">
                {wishlistCount}
              </span>
            )}
          </div>
          <span className="text-[10px] font-medium font-heading">Wishlist</span>
        </button>
        
        <button 
          onClick={onCartClick} 
          className="flex flex-col items-center justify-center w-full h-full text-gray-500 hover:text-herbal-800 active:text-herbal-800 transition-colors gap-1 relative group"
        >
          <div className="relative">
            <ShoppingBag className="h-5 w-5 group-hover:scale-110 transition-transform" />
            {cartCount > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-herbal-800 text-white text-[9px] font-bold rounded-full h-3.5 w-3.5 flex items-center justify-center border border-white shadow-sm">
                {cartCount}
              </span>
            )}
          </div>
          <span className="text-[10px] font-medium font-heading">Cart</span>
        </button>
      </div>
    </div>
  );
};